import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { comedywritingfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Falcon Book Writing | Comedy Writing Experts
        </title>
        <meta
          name="description"
          content="Hire expert comedy writers with Falcon Book Writing to produce funny, engaging scripts, sketches, and content that captivate and entertain your audience."
        />
        <meta name="keywords" content="Comedy Writing Services" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg comedywritingbg"
          title="Comedy Writing That Captures Timing, Tone, and"
          subtitle=" Truth "
          // title2="Partner For Every Genre"
          para="Comedy writing is more than just jokes, it’s about timing, tone, and truth. Our expert comedy writing craft witty, relatable humor that resonates, entertains, and leaves a lasting impression on every audience."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          // title={`We Write, You Take The  `}
          subtitle="  Punchlines "
          title2="That Stick and Stories That Pop"
          description={`Great comedy isn’t just about telling jokes, it’s about creating moments that stick. Every punchline, every setup, and every story is crafted to captivate, surprise, and entertain. Our comedy writing blends sharp wit, relatable humor, and precise timing to deliver laughs that feel effortless yet unforgettable. We focus on crafting narratives that pop, whether it’s a sketch, stand-up routine, web series, or humorous brand content, ensuring the humor resonates with your audience. From clever wordplay to situational comedy, every element is designed to engage and delight. By combining creativity with structure and timing, we transform ideas into comedic gold. The result? Punchlines that land perfectly, stories that stay memorable, and a laughter-filled experience that keeps audiences coming back for more. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={comedywritingfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
